import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "m-0 shrink-0 flex items-center justify-between"
};
const _hoisted_2 = {
  class: "flex items-center gap-2"
};
const _hoisted_3 = {
  class: "hide-scroll-bar h-full box-border overflow-y-auto"
};
const _hoisted_4 = {
  class: "w-full min-h-full relative flex-grow bg-white box-border p-3 sm:p-7"
};
const _hoisted_5 = {
  ref: "mindMapContainer",
  class: "mindmap-container h-[100vh]"
};
import { Markmap } from 'markmap-view';
import { Transformer } from 'markmap-lib';
import { Toolbar } from 'markmap-toolbar';
import { useClipboard } from '@vueuse/core';
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
import { ElLoading } from 'element-plus';
import Icon from '@/components/Icon/src/Icon.vue';
import download from '@/utils/download';
export default /*@__PURE__*/_defineComponent({
  __name: 'Preview',
  props: {
    content: {
      // 生成的结果
      type: String,
      default: ''
    }
  },
  emits: ['handle-close'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const message = useMessage(); // 消息弹窗
    const {
      copied,
      copy
    } = useClipboard(); // 粘贴板
    const emits = __emit;
    /** 通过计算属性，双向绑定，更改生成的内容，考虑到用户想要更改生成文章的情况 */
    const content = computed(() => props.content);
    // 定义模板引用
    const svgRef = ref();
    const toolBarRef = ref();
    // 思维导图实例和转换器
    let markMap = null;
    const transformer = new Transformer();
    const back = () => {
      emits('handle-close');
    };
    /** 点击复制的时候复制内容 */
    const showCopy = computed(() => content.value); // 是否展示复制按钮，在生成内容完成的时候展示
    const showImage = ref(true);
    const copyContent = () => {
      copy(content.value);
    };
    const downloadImage = () => {
      if (!svgRef.value) {
        message.error('无法获取思维导图内容');
        return;
      }
      // 显示加载提示
      const loadingInstance = ElLoading.service({
        lock: true,
        text: '正在生成图片，请稍候...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      try {
        // 获取 SVG 元素的实际尺寸
        const svgElement = svgRef.value;
        const rect = svgElement.getBoundingClientRect();
        const computedStyle = window.getComputedStyle(svgElement);
        // 获取实际渲染尺寸
        const svgSvgElement = svgElement;
        const width = svgSvgElement.viewBox?.baseVal?.width || rect.width || parseInt(computedStyle.width) || 800;
        const height = svgSvgElement.viewBox?.baseVal?.height || rect.height || parseInt(computedStyle.height) || 600;
        // 获取所有样式表
        const styleSheets = Array.from(document.styleSheets);
        let cssText = '';
        try {
          styleSheets.forEach(sheet => {
            try {
              const rules = Array.from(sheet.cssRules || sheet.rules || []);
              rules.forEach(rule => {
                // 只包含与 markmap 相关的样式
                if (rule.cssText && (rule.cssText.includes('markmap') || rule.cssText.includes('mm-'))) {
                  cssText += rule.cssText + '\n';
                }
              });
            } catch (e) {
              // 忽略跨域样式表错误
            }
          });
        } catch (e) {
          console.warn('无法获取样式表:', e);
        }
        // 序列化 SVG
        const serializer = new XMLSerializer();
        let source = serializer.serializeToString(svgElement);
        // 添加必要的命名空间和属性
        if (!source.includes('xmlns=')) {
          source = source.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"');
        }
        if (!source.includes('xmlns:xlink')) {
          source = source.replace('<svg', '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
        }
        // 设置明确的宽高
        if (!source.includes('width=')) {
          source = source.replace('<svg', `<svg width="${width}" height="${height}"`);
        }
        // 如果有样式，添加到 SVG 中
        if (cssText) {
          const styleTag = `<style><![CDATA[${cssText}]]></style>`;
          source = source.replace('>', `>${styleTag}`);
        }
        // 添加 XML 声明
        source = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n${source}`;
        console.log('SVG 数据准备完成，开始下载...', {
          width,
          height,
          hasStyles: !!cssText
        });
        // 关闭加载提示
        loadingInstance.close();
        // 显示处理提示
        message.info('正在处理下载，请稍候...');
        // 使用优化后的 SVG 转 PNG 方法
        download.svgToPng({
          svgData: source,
          fileName: 'mindmap.png',
          width: Math.round(width),
          height: Math.round(height)
        });
        // 延迟显示成功消息（给下载一些时间）
        setTimeout(() => {
          message.success('下载已开始，如果未自动下载请检查浏览器设置');
        }, 1000);
      } catch (error) {
        // 关闭加载提示
        loadingInstance.close();
        console.error('下载图片失败:', error);
        message.error('下载失败，请稍后重试');
      }
    };
    // 渲染思维导图的方法
    const renderMindMap = content => {
      try {
        // 转换 Markdown 为思维导图数据
        const {
          root
        } = transformer.transform(processContent(content));
        // 设置数据并适配视图
        markMap?.setData(root);
        markMap?.fit();
      } catch (e) {
        console.error('渲染思维导图失败:', e);
      }
    };
    const handleShowImage = show => {
      if (show) {
        // 使用 nextTick 确保 DOM 更新完成后再渲染
        nextTick(() => {
          renderMindMap(content.value);
        });
      }
    };
    /** 复制成功的时候 copied.value 为 true */
    watch(copied, val => {
      if (val) {
        message.success('复制成功');
      }
    });
    onMounted(() => {
      // 初始化思维导图
      if (svgRef.value) {
        markMap = Markmap.create(svgRef.value, {
          autoFit: true,
          // 自动适配内容
          fitRatio: 0.8,
          // 适配比例
          paddingX: 20 // 水平内边距
        });
        // 创建工具栏
        if (markMap && toolBarRef.value) {
          const {
            el
          } = Toolbar.create(markMap);
          toolBarRef.value.append(el);
        }
        // 渲染思维导图
        renderMindMap(content.value);
      }
    });
    /** 处理内容 */
    const processContent = text => {
      const arr = [];
      const lines = text.split('\n');
      for (let line of lines) {
        if (line.indexOf('```') !== -1) {
          continue;
        }
        line = line.replace(/([*_~`>])|(\d+\.)\s/g, '');
        arr.push(line);
      }
      return arr.join('\n');
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createBlock(_component_el_card, {
        class: "my-card h-full"
      }, {
        header: _withCtx(() => [_createElementVNode("h3", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: back,
          size: "small"
        }, {
          icon: _withCtx(() => [_createVNode(Icon, {
            icon: "mynaui:fat-arrow-left"
          })]),
          _: 1
        }), _cache[2] || (_cache[2] = _createElementVNode("span", null, "预览", -1)), _createVNode(_component_el_switch, {
          modelValue: showImage.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => showImage.value = $event),
          "inline-prompt": "",
          "active-text": "思维导图",
          "inactive-text": "原始代码",
          onChange: handleShowImage
        }, null, 8, ["modelValue"])]), !showImage.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: copyContent,
          size: "small"
        }, {
          icon: _withCtx(() => [_createVNode(Icon, {
            icon: "ph:copy-bold"
          })]),
          default: _withCtx(() => [_cache[3] || (_cache[3] = _createTextVNode(" 复制 "))]),
          _: 1
        })) : _createCommentVNode("", true), showImage.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          onClick: downloadImage,
          size: "small"
        }, {
          icon: _withCtx(() => [_createVNode(Icon, {
            icon: "ph:download-bold"
          })]),
          default: _withCtx(() => [_cache[4] || (_cache[4] = _createTextVNode(" 下载 "))]),
          _: 1
        })) : _createCommentVNode("", true)])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("div", _hoisted_5, [(_openBlock(), _createElementBlock("svg", {
          ref_key: "svgRef",
          ref: svgRef,
          class: "w-full h-[calc(100vh-100px)]"
        }, null, 512)), _createElementVNode("div", {
          ref_key: "toolBarRef",
          ref: toolBarRef,
          class: "absolute bottom-[20px] right-5"
        }, null, 512)], 512), [[_vShow, showImage.value]]), _withDirectives(_createVNode(_component_el_input, {
          id: "inputId",
          type: "textarea",
          modelValue: content.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => content.value = $event),
          autosize: "",
          "input-style": {
            boxShadow: 'none'
          },
          resize: "none",
          placeholder: "生成的内容……"
        }, null, 8, ["modelValue"]), [[_vShow, !showImage.value]])])])]),
        _: 1
      });
    };
  }
});